import React from "react";
import Alert from "@material-ui/lab/Alert";
import { Grid } from "@material-ui/core";

export default function AlertComponent(props) {
  const { showAlert, severity, message, setAlert } = props;
  return (
    <Grid container justifyContent="center" style={{ marginBottom: "10px" }}>
      {showAlert ? (
        <Alert
          severity={severity}
          fullWidth
          onClose={() =>
            setAlert({
              ...alert,
              showAlert: false,
            })
          }
        >
          {message}
        </Alert>
      ) : null}
    </Grid>
  );
}
